import { render, staticRenderFns } from "./AddReceiptType.vue?vue&type=template&id=3fedd0a3&scoped=true&"
import script from "./AddReceiptType.vue?vue&type=script&lang=js&"
export * from "./AddReceiptType.vue?vue&type=script&lang=js&"
import style0 from "./AddReceiptType.vue?vue&type=style&index=0&id=3fedd0a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fedd0a3",
  null
  
)

export default component.exports